// extracted by mini-css-extract-plugin
export default {"pinterest-share-link":"pinterest-share-link--mp-oKZ3a","pinterestShareLink":"pinterest-share-link--mp-oKZ3a"};